import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ServerConstants} from "../../../model/ServerConstants";
import {TopLevelDomain, TrustAnchor} from '@iana-rzms/bff-sdk';
import {ChangeVO} from '../../../generate/ChangeVO';


@Component({
    selector: 'trust-anchors',
    templateUrl: './trust-anchors.component.html',
    styleUrls: ['./trust-anchors.component.scss'],
    standalone: false
})
export class TrustAnchorsComponent implements OnInit {

  @Input()
  domain: TopLevelDomain;
  editmode: boolean;
  @Input()
  trustAnchorsChange: ChangeVO;
  @Input()
  pendingRequestChangeID: string;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomain>();
  @Input()
  viewMode: boolean;
  @Input()
  hasTechnicalPermission: boolean;
  serverConstants = ServerConstants;
  constructor() { }

  ngOnInit() {
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  trustAnchorsOutput(trustAnchors: Array<TrustAnchor>) {
    this.domain.trustAnchors = trustAnchors;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }
}
